import { ref, type Ref } from "vue";

export const useConfirmDelete = <T>(onConfirm: (item: T) => void | Promise<void>) => {
  const isOpen = ref(false);
  const target = ref(null) as Ref<T | null>;

  const requestDelete = (item: T) => {
    target.value = item;
    isOpen.value = true;
  };

  const confirm = async () => {
    if (!target.value) return;
    await onConfirm(target.value);
    target.value = null;
    isOpen.value = false;
  };

  return { isOpen, target, requestDelete, confirm };
};
